import { BROKER_LOGO } from "@/config/logos";

export const brokersList = [
  {
    id: "4",
    name: "Alpaca",
    note: <p></p>,
    logo: BROKER_LOGO["ALPACA"].DARK.textLogo,
    icon: BROKER_LOGO["ALPACA"].DARK.logo,
    defaultPassphrase: "s",
    type: "virtual",
    plan: "free",
    footerLink: "https://app.alpaca.markets/signup",
    leverage: 0.5,
    maintainance: 0.25,
    disabled: false,
    initialMarginHint:
      "Alpaca applies a minimum initial margin requirement of 50% for marginable securities and 100% for non-marginable securities.",
    maintainanceMarginHint:
      "FINRA has set the minimum maintenance requirement to at least 25% of the total market value.",
  },
  {
    id: "1",
    name: "Match Trade ",
    note: <p></p>,
    defaultApiSecret: "0",
    logo: BROKER_LOGO["MATCHTRADE"].DARK.textLogo,
    icon: BROKER_LOGO["MATCHTRADE"].DARK.logo,
    type: "virtual",
    plan: "pro",
    footerLink: "https://match-trader.com/",
    leverage: 0.01,
    maintainance: 0.01,
    disabled: false,
  },
  {
    id: "2",
    name: "Ctrader",
    note: <p></p>,
    disabled: false,
    logo: BROKER_LOGO["CTRADER"].DARK.textLogo,
    icon: BROKER_LOGO["CTRADER"].DARK.logo,
    defaultPassphrase: "live",
    type: "live",
    plan: "pro",
    footerLink: "https://ctrader.com/download",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "13",
    name: "Lightspeed",
    note: <p></p>,
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    logo: BROKER_LOGO["LIGHTSPEED"].DARK.textLogo,
    icon: BROKER_LOGO["LIGHTSPEED"].DARK.logo,
    type: "live",
    footerLink: "https://lightspeed.com/trading/api-trading/level2",
    leverage: 1,
    maintainance: 0.25,
    initialMarginHint:
      "Lightspeed has a minimum initial margin requirement of 100%. Upgrade to a Reg T account to borrow up to 50% of the total purchase price of a security.",
    maintainanceMarginHint:
      "FINRA has set the minimum maintenance requirement to at least 25% of the total market value.",
  },
  {
    id: "11",
    name: "Leverate",
    disabled: false,
    note: <p>{""}</p>,
    defaultPassphrase: "%20",
    logo: BROKER_LOGO["LEVERATE"].DARK.textLogo,
    icon: BROKER_LOGO["LEVERATE"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "14",
    name: "MetaTrader 5",
    note: <p></p>,
    logo: BROKER_LOGO["MT5"].DARK.textLogo,
    icon: BROKER_LOGO["MT5"].DARK.logo,
    type: "live",
    plan: "pro",
    footerLink: "https://www.metatrader5.com/",
    leverage: 0.01,
    maintainance: 0.01,
    disabled: false,
  },
  {
    id: "17",
    name: "Fennel",
    disabled: false,
    defaultPassphrase: "%20",
    note: <p></p>,
    logo: BROKER_LOGO["FENNEL"].DARK.textLogo,
    icon: BROKER_LOGO["FENNEL"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "20",
    name: "Webull",
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p></p>,
    logo: BROKER_LOGO["WEBBULLS"].DARK.textLogo,
    icon: BROKER_LOGO["WEBBULLS"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },

  {
    id: "19",
    name: "Public",
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p> </p>,
    logo: BROKER_LOGO["PUBLIC"].DARK.textLogo,
    icon: BROKER_LOGO["PUBLIC"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "5",
    name: "Trade Zero",
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p>{""}</p>,
    logo: BROKER_LOGO["TRADEZERO"].DARK.textLogo,
    icon: BROKER_LOGO["TRADEZERO"].DARK.logo,
    type: "virtual",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "18",
    name: "Trade Station",
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p></p>,
    logo: BROKER_LOGO["TRADESTATION"].DARK.textLogo,
    icon: BROKER_LOGO["TRADESTATION"].DARK.logo,
    type: "virtual",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "13",
    name: "Lightspeed",
    note: <p></p>,
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    logo: BROKER_LOGO["LIGHTSPEED"].DARK.textLogo,
    icon: BROKER_LOGO["LIGHTSPEED"].DARK.logo,
    type: "live",
    plan: "elite",
    footerLink: "https://lightspeed.com/trading/api-trading/level2",
    leverage: 1,
    maintainance: 0.25,
    initialMarginHint:
      "Lightspeed has a minimum initial margin requirement of 100%. Upgrade to a Reg T account to borrow up to 50% of the total purchase price of a security.",
    maintainanceMarginHint:
      "FINRA has set the minimum maintenance requirement to at least 25% of the total market value.",
  },
  {
    id: "26",
    name: "Sterling",
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p></p>,
    logo: BROKER_LOGO["STERLING"].DARK.textLogo,
    icon: BROKER_LOGO["STERLING"].DARK.logo,
    type: "live",
    plan: "elite",
    leverage: 0.01,
    maintainance: 0.01,
  },
];

export const brokerOptions = Object.fromEntries(
  brokersList.map((broker) => [
    broker.id,
    {
      id: Number(broker.id),
      value: Number(broker.id),
      label: broker.name.trim(),
      leverage: broker.leverage,
      maintainance: broker.maintainance,
      disabled: broker.disabled,
      initialMarginHint: broker.initialMarginHint,
      maintainanceMarginHint: broker.maintainanceMarginHint,
      type: broker.type,
    },
  ]),
);
